import axios from './index';

class SavingsPlanApi {
  static List = (data) => {
    let query = '?';
    if (data.savingsPlanId) {
      query += `name=${data.savingsPlanId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      name: data.category,
      metal_type: data.type,
      category: data.category,
      short_details: { text: data.description },
      display_order: Number(data.order),
      is_active: data.status === 'true' ? true : false,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.name) request.name = data.name;
    if (data.type) request.metal_type = data.type;
    if (data.category) request.category = data.category;
    if (data.order) request.display_order = Number(data.order);
    if (data.description) request.short_details = { text: data.description };
    if (data.isActive)
      request.is_active = data.isActive === 'true' ? true : false;
    return axios.put(`${base}/${data.savingsPlanId}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };
}

let base = 'dashboard/saving-plan';

export default SavingsPlanApi;
